import React from "react";
import styles from "./styles.module.scss";
import { PrimitiveProps } from "@helpers/interfaces/primitive";
import { Icon } from "@components/Icon/Icon";
import searchIcon from "@svg-icons/search.component.svg";
import { Button } from "@components/Button/Button";
import classnames from "classnames";
import { useSharedNavToggleState } from "@components/Navigation/Navigation";
export type SearchFieldProps = PrimitiveProps & {
  useDarkHeader?: boolean;
};

const SearchField: React.FC<SearchFieldProps> = (props) => {
  const { isActive } = useSharedNavToggleState();

  let query = "" as string | null;
  if (global.window) {
    query = new URLSearchParams(global.window.location.search).get("query");
    if (query) {
      query = decodeURI(query);
    }
  }
  return (
    <form
      className={classnames(
        styles.searchContainer,
        isActive && styles.searchContainerNavActive,
        props.useDarkHeader && styles.searchDarkThemeContainer
      )}
      action="/sogning"
      method="get"
    >
      <input
        onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            if (e.currentTarget.value === "") e.preventDefault();
          }
        }}
        type="text"
        name="query"
        placeholder="Søg"
        {...(query && { defaultValue: query })}
        className={classnames(styles.searchInput, props.useDarkHeader && styles.searchDarkTheme)}
      />
      <Button type="submit" className={styles.searchButton} aria-label="Søg">
        <Icon svg={searchIcon} className={classnames(styles.searchIcon, props.useDarkHeader && styles.darkThemeIcon)} />
      </Button>
      <label aria-label="Søg"></label>
    </form>
  );
};

SearchField.defaultProps = {};

export { SearchField };
